import { ordinal } from "@gymflow/helpers";
import { EventRsvpCustomerDTO } from "@gymflow/types";
import {
  DotBadge,
  DotBadgeProps,
} from "apps/portal/src/components/atoms/DotBadge";
import { useTranslation } from "react-i18next";

export type InvoiceBadgeProps = {
  booking: Pick<EventRsvpCustomerDTO, "status" | "waitlistPosition">;
};

export const BookingStatusClassBadge = ({ booking }: InvoiceBadgeProps) => {
  const { t } = useTranslation();
  return (
    <DotBadge
      intent={
        (
          {
            WAITING: "warning",
            BOOKED: "lightblue",
            ATTENDED: "success",
            CANCELLED: "warning",
            LATE_CANCELLED: "error",
            NO_SHOW: "error",
          } as {
            [key in EventRsvpCustomerDTO["status"]]: DotBadgeProps["intent"];
          }
        )[booking.status]
      }
      size="small"
    >
      {booking.status === "WAITING"
        ? booking?.waitlistPosition
          ? t("portal.common.positionOnWaitlist", {
              position: ordinal(booking.waitlistPosition),
            })
          : t("portal.common.waitlist")
        : t(`portal.common.rsvpStatus.${booking.status}`)}
    </DotBadge>
  );
};
